module.exports = __webpack_public_path__ + "img/2_270.be98f34f.png";